// extracted by mini-css-extract-plugin
module.exports = {"list":"MainNav_list__3fQzW"};